
window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

window.FazendaRP.Pages.financeiro.dashboard = {
    charts: {},

    render: async function (container) {
        const currentYear = new Date().getFullYear();
        container.innerHTML = `
            <div id="fin-dashboard-wrapper" class="fade-in" style="padding-bottom: 50px;">
                
                <!-- HEADER & FILTROS -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 25px;">
                    <div>
                        <h2 style="margin: 0; font-size: 1.5rem; color: #1f2937;">Visão Financeira & Resultados</h2>
                        <p style="margin: 5px 0 0; color: #6b7280; font-size: 0.9rem;">Gestão de Caixa, DRE e Safras.</p>
                    </div>
                    <div style="display:flex; gap:10px;">
                         <select id="dash-year-select" style="padding: 8px 16px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 0.9rem; color: #374151; min-width:120px;">
                            <option value="${currentYear}" selected>Ano ${currentYear}</option>
                            <option value="${currentYear - 1}">Ano ${currentYear - 1}</option>
                            <option value="${currentYear - 2}">Ano ${currentYear - 2}</option>
                         </select>
                         <button id="btn-refresh-dash" title="Atualizar" style="background:white; border:1px solid #e5e7eb; padding:8px 12px; border-radius:6px; cursor:pointer;"><i class="fas fa-sync-alt"></i></button>
                    </div>
                </div>

                <!-- ROW 1: DRE SINTÉTICO (KPIs) -->
                <h3 style="margin: 0 0 10px 0; font-size: 0.85rem; color: #6b7280; text-transform:uppercase; font-weight:600;">Resultado do Exercício (DRE)</h3>
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px; margin-bottom: 25px;">
                    
                    <!-- Receita -->
                    <div class="card" style="padding:20px; border-top: 4px solid #3b82f6;">
                        <div style="font-size:0.8rem; text-transform:uppercase; color:#6b7280; font-weight:600;">Receita Bruta</div>
                        <div id="kpi-dre-receita" style="font-size:1.6rem; font-weight:700; color:#1f2937; margin:8px 0;">...</div>
                        <div id="kpi-dre-receita-sub" style="font-size:0.8rem; color:#6b7280;">Carregando...</div>
                    </div>

                    <!-- Custos -->
                    <div class="card" style="padding:20px; border-top: 4px solid #ef4444;">
                        <div style="font-size:0.8rem; text-transform:uppercase; color:#6b7280; font-weight:600;">Custos / Despesas</div>
                        <div id="kpi-dre-custo" style="font-size:1.6rem; font-weight:700; color:#ef4444; margin:8px 0;">...</div>
                        <div style="font-size:0.8rem; color:#6b7280;">Operacional + Fixo</div>
                    </div>

                    <!-- Resultado -->
                    <div class="card" style="padding:20px; border-top: 4px solid #10b981;">
                        <div style="display:flex; justify-content:space-between;">
                            <div style="font-size:0.8rem; text-transform:uppercase; color:#6b7280; font-weight:600;">Lucro Operacional</div>
                             <div id="kpi-dre-margem" style="font-size:0.8rem; background:#dcfce7; color:#166534; padding:2px 6px; border-radius:4px; font-weight:700;">--%</div>
                        </div>
                        <div id="kpi-dre-resultado" style="font-size:1.6rem; font-weight:700; color:#10b981; margin:8px 0;">...</div>
                        <div style="font-size:0.8rem; color:#6b7280;">EBITDA</div>
                    </div>

                </div>

                <!-- ROW 2: FLUXO & ALERTAS -->
                <div style="display: grid; grid-template-columns: 2fr 1fr; gap: 20px; margin-bottom: 25px;">
                    
                    <!-- Fluxo Chart -->
                    <div class="card" style="padding: 20px;">
                        <div style="display:flex; justify-content:space-between; margin-bottom:15px;">
                             <h4 style="margin: 0; color: #374151; font-size: 1rem;">Fluxo de Caixa (Realizado vs Projetado)</h4>
                             <div style="font-size:0.75rem; color:#6b7280; display:flex; gap:10px;">
                                <span style="display:flex; align-items:center; gap:4px;"><span style="width:10px; height:2px; background:#10b981;"></span> Realizado</span>
                                <span style="display:flex; align-items:center; gap:4px;"><span style="width:10px; height:2px; background:#9ca3af; border:1px dashed #9ca3af;"></span> Projetado</span>
                             </div>
                        </div>
                        <div style="height: 280px; position:relative;">
                            <canvas id="chartFluxo"></canvas>
                        </div>
                    </div>

                    <!-- RIGHT COL: CARDS & ALERTS -->
                    <div style="display:flex; flex-direction:column; gap:20px;">
                        
                        <!-- WIDGET CARTÃO (New) -->
                        <div id="widget-cc-container" class="card" style="padding:0; border:1px solid #e5e7eb; overflow:hidden; min-height:150px;">
                            <div style="display:flex; align-items:center; justify-content:center; height:100%; color:#9ca3af; padding:20px;">
                                <i class="fas fa-spinner fa-spin"></i> Carregando Cartão...
                            </div>
                        </div>

                        <!-- Alertas (Inadimplência) -->
                        <div class="card" style="background:#fef2f2; border:1px solid #fecaca; padding:0; overflow:hidden; display:flex; flex-direction:column; flex:1;">
                            <div style="padding:15px; border-bottom:1px solid #fecaca;">
                                <h4 style="margin:0; font-size:1rem; color:#991b1b; display:flex; align-items:center;">
                                    <i class="fas fa-exclamation-triangle" style="margin-right:8px;"></i> Contas em Atraso
                                </h4>
                            </div>
                            
                            <div id="list-alerts" style="padding:0; flex:1; overflow-y:auto; max-height:250px;">
                                <div style="text-align:center; padding:20px; color:#aaa;">Verificando...</div>
                            </div>
                            
                            <div style="padding:10px; background:#fef2f2; text-align:center; border-top:1px solid #fecaca;">
                                <small style="color:#7f1d1d;">Fatura Cartões (Est.): <b id="kpi-cartao-div">...</b></small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ROW 3: SAFRAS & PARCEIROS -->
                <div style="display: grid; grid-template-columns: 1.5fr 1fr; gap: 20px;">
                    
                    <!-- Tabela Safras -->
                    <div class="card" style="padding: 20px;">
                        <h4 style="margin: 0 0 15px 0; color: #374151; font-size: 1rem;">Resultado por Safra (Analítico)</h4>
                        <div style="overflow-x:auto;">
                            <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                                <thead>
                                    <tr style="border-bottom:1px solid #eee; color:#6b7280; font-size:0.8rem; text-transform:uppercase;">
                                        <th style="padding:8px; text-align:left;">Safra</th>
                                        <th style="padding:8px; text-align:right;">Receita</th>
                                        <th style="padding:8px; text-align:right;">Despesa</th>
                                        <th style="padding:8px; text-align:right;">Lucro</th>
                                    </tr>
                                </thead>
                                <tbody id="table-safras-body">
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Top Parceiros -->
                    <div class="card" style="padding: 20px;">
                        <div style="display:flex; justify-content:space-between; margin-bottom:15px;">
                            <h4 style="margin: 0; color: #374151; font-size: 1rem;">Top Parceiros</h4>
                            <select id="sel-top-partners-dash" style="font-size:0.8rem; padding:2px;"><option value="fornecedores">Fornecedores</option><option value="clientes">Clientes</option></select>
                        </div>
                        <div style="height: 220px; position:relative;">
                            <canvas id="chartPartners"></canvas>
                        </div>
                    </div>

                </div>
            </div>
        `;

        this.initEvents();
        await this.autoSelectYear();
        this.loadData();
    },

    initEvents: function () {
        document.getElementById('dash-year-select').addEventListener('change', () => this.loadData());
        document.getElementById('btn-refresh-dash').addEventListener('click', () => this.loadData());
        document.getElementById('sel-top-partners-dash').addEventListener('change', (e) => this.renderPartnersChart(this.cachedData, e.target.value));
    },

    autoSelectYear: async function () {
        const currentYear = new Date().getFullYear();
        const select = document.getElementById('dash-year-select');

        if (select) {
            // Force 2025 as default if not updated
            if (!select.querySelector(`option[value="${currentYear}"]`)) {
                const opt = document.createElement('option');
                opt.value = currentYear;
                opt.innerText = `Ano ${currentYear}`;
                select.insertBefore(opt, select.firstChild);
            }
            select.value = currentYear;
        }
    },

    loadData: async function () {
        const year = document.getElementById('dash-year-select').value;
        const start = `${year}-01-01`;
        const end = `${year}-12-31`;

        // LOAD 1: Lancamentos
        // NO 'safra_id' column in select, we use detalhes
        const { data: lancamentos, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('id, tipo, status, valor, data_vencimento, data_emissao, data_pagamento, descricao, detalhes, parceiros(id, nome)')
            .gte('data_emissao', start)
            .lte('data_emissao', end)
            .neq('status', 'Cancelado');

        if (error) {
            console.error('Dash Fin SQL Error:', error);
            const kpi = document.getElementById('kpi-dre-receita-sub');
            if (kpi) kpi.innerText = `Erro: ${error.message}`;
            return;
        }

        // LOAD 2: Safras
        const { data: safras } = await window.FazendaRP.supabase.from('safras').select('*');

        // LOAD 3: Overdue
        const today = new Date().toISOString().split('T')[0];
        const { data: overdue } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('id, valor, descricao, data_vencimento, parceiros(nome)')
            .eq('status', 'Pendente')
            .eq('tipo', 'Despesa')
            .lt('data_vencimento', today)
            .order('data_vencimento', { ascending: true })
            .limit(10);

        // LOAD 4: Credit Card Debt
        const debt = await this.fetchCardBalance();

        this.cachedData = { lancamentos, safras, overdue, debt };
        this.processData(this.cachedData);

        // Render Fluxo separately (Async/Complex Logic)
        await this.loadSafrasAnalytics();
        await this.renderFluxoChart();
        this.loadCreditCardWidget();
    },

    processData: function (data) {
        if (!data || !data.lancamentos) return;

        let receita = 0;
        let despesa = 0;

        data.lancamentos.forEach(l => {
            const val = parseFloat(l.valor || 0);

            // DRE Totals
            if (l.tipo === 'Receita' || l.tipo === 'RECEITA') {
                receita += val;
            } else if (l.tipo === 'Despesa' || l.tipo === 'DESPESA') {
                despesa += val;
            }
        });

        // Update KPIs
        // Update KPIs (With Safety Checks)
        const elRec = document.getElementById('kpi-dre-receita');
        if (elRec) elRec.innerText = receita.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        const elRecSub = document.getElementById('kpi-dre-receita-sub');
        if (elRecSub) elRecSub.innerText = 'Confirmado + Pendente';

        const elCusto = document.getElementById('kpi-dre-custo');
        if (elCusto) elCusto.innerText = despesa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        const resultado = receita - despesa;
        const elRes = document.getElementById('kpi-dre-resultado');
        if (elRes) elRes.innerText = resultado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        const margem = receita > 0 ? (resultado / receita) * 100 : 0;
        const elMargem = document.getElementById('kpi-dre-margem');
        if (elMargem) {
            elMargem.innerText = `${margem.toFixed(1)}%`;
            elMargem.style.background = resultado < 0 ? '#fef2f2' : '#dcfce7';
            elMargem.style.color = resultado < 0 ? '#ef4444' : '#166534';
        }

        // Render Lists/Charts
        this.renderPartnersChart(data, 'fornecedores');
        this.renderOverdue(data.overdue);

        const elCardDiv = document.getElementById('kpi-cartao-div');
        if (elCardDiv) elCardDiv.innerText = (data.debt || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    loadSafrasAnalytics: async function () {
        const tbody = document.getElementById('table-safras-body');
        if (tbody) tbody.innerHTML = '<tr><td colspan="4" style="text-align:center; padding:20px;">Carregando safras...</td></tr>';

        try {
            // 1. Fetch Top 8 Safras (Latest Years)
            const { data: safras, error: errSafra } = await window.FazendaRP.supabase
                .from('safras')
                .select('*')
                .order('ano', { ascending: false })
                .limit(8);

            if (errSafra) throw new Error('Erro ao buscar safras');
            if (!safras || safras.length === 0) {
                this.renderSafrasTableDirect([]);
                return;
            }

            const safraMap = {};
            safras.forEach(s => {
                safraMap[s.id] = {
                    nome: s.ano + (s.cultura ? ` - ${s.cultura}` : ''),
                    rec: 0,
                    desp: 0
                };
            });

            // 2. Fetch Lancamentos (All time, non-cancelled)
            // Selecting 'rateio' column just in case, along with details
            const { data: lancs, error: errLanc } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('valor, tipo, detalhes')
                .neq('status', 'Cancelado');

            if (errLanc) throw new Error('Erro ao buscar lançamentos');

            // Helper to parse currency (string or number)
            const parseVal = (v) => {
                if (typeof v === 'number') return v;
                if (typeof v === 'string') {
                    // Handles "R$ 1.000,00" -> 1000.00
                    return parseFloat(v.replace(/[^\d,-]/g, '').replace(',', '.')) || 0;
                }
                return 0;
            };

            // 3. Aggregate
            (lancs || []).forEach(l => {
                const tipo = (l.tipo || '').toUpperCase();

                // Collect all extracted Rateios
                let allRateios = [];
                let details = l.detalhes;
                if (typeof details === 'string') {
                    try { details = JSON.parse(details); } catch (e) { }
                }

                // A. Check Root 'rateio' column
                if (l.rateio) {
                    let r = l.rateio;
                    if (typeof r === 'string') try { r = JSON.parse(r); } catch (e) { }
                    if (Array.isArray(r)) allRateios.push(...r);
                    else if (typeof r === 'object') allRateios.push(r);
                }

                // B. Check Details
                if (details) {
                    // Singular 'rateio' (standard in some forms) or Plural 'rateios' (legacy)
                    if (details.rateio && Array.isArray(details.rateio)) allRateios.push(...details.rateio);
                    else if (details.rateio && typeof details.rateio === 'object') allRateios.push(details.rateio); // Object case

                    if (details.rateios && Array.isArray(details.rateios)) allRateios.push(...details.rateios);

                    // C. Check Items (Itens may have individual rateios)
                    if (details.itens && Array.isArray(details.itens)) {
                        details.itens.forEach(item => {
                            if (item.rateio && Array.isArray(item.rateio)) allRateios.push(...item.rateio);
                            else if (item.rateio && typeof item.rateio === 'object') allRateios.push(item.rateio);
                        });
                    }

                    // D. Fallback: Single Safra ID in details root?
                    // Only if NO rateios found to avoid double counting
                    if (allRateios.length === 0 && details.safra_id) {
                        allRateios.push({ safra_id: details.safra_id, valor: l.valor });
                    }
                }

                if (allRateios.length === 0) return;

                // Sum for mapped safras
                allRateios.forEach(r => {
                    // Loose comparison for ID (String vs Number)
                    const sId = r.safra_id;
                    // We check if sId exists in our Top 8 map
                    if (sId && safraMap[sId]) {
                        const val = parseVal(r.valor);
                        if (tipo === 'RECEITA') safraMap[sId].rec += val;
                        else safraMap[sId].desp += val;
                    }
                });
            });

            // 4. Render
            const resultList = safras.map(s => ({
                id: s.id,
                nome: safraMap[s.id].nome,
                rec: safraMap[s.id].rec,
                desp: safraMap[s.id].desp
            }));

            this.renderSafrasTableDirect(resultList);

        } catch (e) {
            console.error('Safra Analytics Error:', e);
            if (tbody) tbody.innerHTML = `<tr><td colspan="4" style="color:red; text-align:center;">Erro: ${e.message}</td></tr>`;
        }
    },

    renderSafrasTableDirect: function (list) {
        const tbody = document.getElementById('table-safras-body');
        if (!tbody) return;

        if (list.length === 0) {
            tbody.innerHTML = '<tr><td colspan="4" style="text-align:center; padding:20px; color:#9ca3af;">Nenhuma safra encontrada.</td></tr>';
            return;
        }

        tbody.innerHTML = list.map(item => {
            const lucro = item.rec - item.desp;
            return `
                <tr style="border-bottom:1px solid #f9fafb;">
                    <td style="padding:10px; font-weight:600; color:#374151;">${item.nome}</td>
                    <td style="padding:10px; text-align:right; color:#10b981;">${item.rec.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td style="padding:10px; text-align:right; color:#ef4444;">${item.desp.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td style="padding:10px; text-align:right; font-weight:700; color:${lucro >= 0 ? '#10b981' : '#ef4444'};">${lucro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
            `;
        }).join('');
    },



    loadCreditCardWidget: async function (selectedDateStr) {
        // selectedDateStr format: "YYYY-MM" (Target Due Month)
        const container = document.getElementById('widget-cc-container');
        if (!container) return;

        try {
            // 1. Find Credit Card Account (Assume first one found)
            const { data: accounts } = await window.FazendaRP.supabase
                .from('financeiro_contas')
                .select('*')
                .eq('tipo', 'Cartão de Crédito')
                .limit(1);

            if (!accounts || accounts.length === 0) {
                container.innerHTML = '<div style="padding:20px; text-align:center; color:#9ca3af;">Nenhum cartão cadastrado.</div>';
                return;
            }

            const card = accounts[0]; // Primary Card
            const diaFechamento = card.dia_fechamento || 10;
            const diaVencimento = card.dia_vencimento || 15;

            // 2. Determine "Target Invoice" Month/Year
            const today = new Date();
            let targetMonth, targetYear;

            if (selectedDateStr) {
                const parts = selectedDateStr.split('-');
                targetYear = parseInt(parts[0]);
                targetMonth = parseInt(parts[1]) - 1; // 0-11
            } else {
                // Default Logic: If today > closing, Target is Next Month
                const currentDay = today.getDate();
                targetMonth = today.getMonth();
                targetYear = today.getFullYear();

                if (currentDay > diaFechamento) {
                    targetMonth++;
                    if (targetMonth > 11) { targetMonth = 0; targetYear++; }
                }
            }

            // 3. Calc Period (Start = Previous Closing + 1, End = Current Closing)
            let startMonth = targetMonth - 1;
            let startYear = targetYear;
            if (startMonth < 0) { startMonth = 11; startYear--; }

            const startDate = new Date(startYear, startMonth, diaFechamento + 1);
            const endDate = new Date(targetYear, targetMonth, diaFechamento, 23, 59, 59);

            const startStr = startDate.toISOString().split('T')[0];
            const endStr = endDate.toISOString().split('T')[0];

            // 4. Fetch Transactions
            const { data: lancs, error } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('*')
                .eq('conta_id', card.id)
                .neq('status', 'Cancelado')
                .gte('data_emissao', startStr)
                .lte('data_emissao', endStr)
                .order('data_emissao', { ascending: false });

            if (error) throw error;

            // 5. Sum
            let total = 0;
            (lancs || []).forEach(l => {
                const v = parseFloat(l.valor);
                if (l.tipo === 'Despesa' || l.tipo === 'DESPESA') total += v;
                else total -= v;
            });

            // 6. Generate Dropdown Options (Past 6 + Future 2)
            const options = [];
            let tempD = new Date(today.getFullYear(), today.getMonth() - 5, 1);
            const limitD = new Date(today.getFullYear(), today.getMonth() + 3, 0);

            while (tempD <= limitD) {
                const y = tempD.getFullYear();
                const m = tempD.getMonth();
                const val = `${y}-${String(m + 1).padStart(2, '0')}`;

                // Label: "Jan/25"
                const mName = tempD.toLocaleString('pt-BR', { month: 'short' });
                const label = `${mName.charAt(0).toUpperCase() + mName.slice(1)}/${String(y).slice(2)}`;

                const isSelected = (y === targetYear && m === targetMonth);
                options.push(`<option value="${val}" ${isSelected ? 'selected' : ''} style="color:#000; background-color:#fff;">${label}</option>`);

                tempD.setMonth(tempD.getMonth() + 1);
            }

            // 7. Render
            const invoiceDate = new Date(targetYear, targetMonth, diaVencimento);
            const dueStr = invoiceDate.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
            const top3 = (lancs || []).slice(0, 3);

            container.innerHTML = `
                <div style="background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%); color: white; padding: 20px; display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
                    <div>
                        <div style="display:flex; justify-content:space-between; align-items:start;">
                            <div style="font-size:0.85rem; color:#94a3b8; text-transform:uppercase; letter-spacing:0.5px;">${card.nome}</div>
                            <div style="font-size:1.2rem; opacity:0.8;"><i class="fab fa-cc-mastercard"></i></div>
                        </div>
                        
                        <!-- DROP FILTER -->
                        <div style="margin-top:15px; margin-bottom:5px;">
                             <select id="cc-invoice-selector" style="background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: white; padding: 4px 8px; border-radius: 4px; font-size: 0.85rem; outline:none; width:100%;">
                                ${options.join('')}
                             </select>
                        </div>

                        <div style="margin-top:10px;">
                            <div style="font-size:0.8rem; color:#cbd5e1;">Fatura (Venc ${dueStr})</div>
                             <div style="font-size:0.7rem; color:#64748b;">De: ${startStr.split('-').reverse().slice(0, 2).join('/')} a ${endStr.split('-').reverse().slice(0, 2).join('/')}</div>
                            <div style="font-size:1.8rem; font-weight:700; color:#fff;">R$ ${total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                        </div>
                    </div>

                    <div style="margin-top:20px; border-top:1px solid rgba(255,255,255,0.1); padding-top:15px;">
                        <div style="font-size:0.75rem; color:#64748b; margin-bottom:10px; font-weight:600;">ÚLTIMOS LANÇAMENTOS</div>
                        ${top3.length === 0 ? '<div style="font-size:0.8rem; color:#64748b; font-style:italic;">Nenhuma compra neste período.</div>' :
                    top3.map(l => `
                            <div style="display:flex; justify-content:space-between; font-size:0.85rem; margin-bottom:6px; color:#cbd5e1;">
                                <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:65%;" title="${l.descricao}">${l.descricao}</span>
                                <span style="font-weight:600;">R$ ${parseFloat(l.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                            </div>
                          `).join('')
                }
                    </div>
                </div>
            `;

            // Event Listener for Dropdown
            const sel = document.getElementById('cc-invoice-selector');
            if (sel) {
                sel.addEventListener('change', (e) => {
                    this.loadCreditCardWidget(e.target.value);
                });
            }

        } catch (e) {
            console.error("CC Widget Error:", e);
            container.innerHTML = `<div style="padding:20px; color:#ef4444; font-size:0.8rem;">Erro ao carregar cartão: ${e.message}</div>`;
        }
    },

    renderFluxoChart: async function () {
        const ctx = document.getElementById('chartFluxo');
        if (!ctx) return;

        try {
            // --- 0. DATE RANGE SETUP (Rolling 2 Years: -1 year to +1 year) ---
            const today = new Date();
            // Start: 1st day of month, 1 year ago
            const startDate = new Date(today.getFullYear() - 1, today.getMonth(), 1);
            // End: Last day of month, 1 year ahead
            const endDate = new Date(today.getFullYear() + 1, today.getMonth() + 1, 0);

            const startStr = startDate.toISOString().split('T')[0]; // YYYY-MM-DD
            const endStr = endDate.toISOString().split('T')[0];     // YYYY-MM-DD

            // Generate Month Buckets (Labels and Keys)
            const buckets = [];
            let tempDate = new Date(startDate);
            while (tempDate <= endDate) {
                const y = tempDate.getFullYear();
                const m = tempDate.getMonth(); // 0-11
                const key = `${y}-${String(m + 1).padStart(2, '0')}`; // "2024-12"

                // Label: "Dez/24"
                const monthName = tempDate.toLocaleString('pt-BR', { month: 'short' });
                const label = `${monthName.charAt(0).toUpperCase() + monthName.slice(1)}/${String(y).slice(2)}`;

                buckets.push({ key, label, real: 0, proj: 0 });

                // Next Month
                tempDate.setMonth(tempDate.getMonth() + 1);
            }

            // --- 1. CONFIG CARTÕES ---
            const { data: ccs, error: errCC } = await window.FazendaRP.supabase
                .from('financeiro_contas')
                .select('id, dia_fechamento')
                .eq('tipo', 'Cartão de Crédito');

            if (errCC) throw new Error('Falha ao buscar cartões: ' + errCC.message);

            const ccMap = {};
            const ccIds = [];
            (ccs || []).forEach(c => {
                ccMap[c.id] = { diaFechamento: c.dia_fechamento || 10 };
                ccIds.push(c.id);
            });

            const getCartaoTargetDate = (dStr, cardId) => {
                const info = ccMap[cardId];
                if (!info) return dStr;
                const parts = dStr.split('-');
                const y = parseInt(parts[0]);
                const m = parseInt(parts[1]);
                const d = parseInt(parts[2]);

                let invM = m - 1;
                let invY = y;
                if (d > info.diaFechamento) {
                    invM++;
                    if (invM > 11) { invM = 0; invY++; }
                }
                const finalM = invM + 1;
                return `${invY}-${String(finalM).padStart(2, '0')}-01`; // Returns YYYY-MM-01 based on due month
            };

            const getBucketIndex = (dStr) => {
                const parts = dStr.split('-');
                const key = `${parts[0]}-${parts[1]}`; // YYYY-MM
                return buckets.findIndex(b => b.key === key);
            };

            // --- 2. FETCH DATA ---
            // A. Projetado (Vencimento in range)
            const pProj = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, data_vencimento, status, conta_id')
                .neq('status', 'Cancelado')
                .gte('data_vencimento', startStr) // Optimized filter
                .lte('data_vencimento', endStr);

            // B. Realizado (Pagamento in range)
            const pReal = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, data_pagamento, status, conta_id')
                .eq('status', 'Pago')
                .gte('data_pagamento', startStr)
                .lte('data_pagamento', endStr);

            // C. Saldo Inicial (Everything BEFORE startStr)
            // Note: For balance calculation we need all history up to startStr
            const pSaldo = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo')
                .eq('status', 'Pago')
                .lt('data_pagamento', startStr);

            const [resProj, resReal, resSaldo] = await Promise.all([pProj, pReal, pSaldo]);

            if (resProj.error) throw new Error('Erro Proj: ' + resProj.error.message);
            if (resReal.error) throw new Error('Erro Real: ' + resReal.error.message);
            if (resSaldo.error) throw new Error('Erro Saldo: ' + resSaldo.error.message);

            const qProj = resProj.data || [];
            const qReal = resReal.data || [];
            const qSaldo = resSaldo.data || [];

            // --- 3. PROCESS ---

            // Calc Initial Balance
            let saldoInicial = 0;
            qSaldo.forEach(l => {
                const val = parseFloat(l.valor || 0);
                // Simple logic: Receita grows, Despesa shrinks
                // Note: We ignore internal transfers if not mapped, but presuming 'tipo' is reliable
                saldoInicial += (String(l.tipo).toUpperCase() === 'RECEITA') ? val : -val;
            });

            // Populate Buckets - Realizado
            qReal.forEach(l => {
                if (!l.data_pagamento) return;
                // Exclude Credit Card payments (bill payments) if using accrual logic? 
                // Logic: Usually we track cash flow. Paying the CC bill reduces cash. Buying with CC doesn't reduce cash immediately.
                // CURRENT LOGIC (inherited): Exclude entries with conta_id in ccIds (assuming these are the individual expenses, not the bill payment?)
                // Or are these the payments OF the bill?
                // inherited logic: if (ccIds.includes(l.conta_id)) return; -> Ignores individual CC purchases for "Realized" cash flow?
                // Assuming individual purchases are "Pago" when entered? No, usually 'Pendente'.
                // If status='Pago' and account='CC', it means it was bought and paid? 
                // Standard convention: CC expenses affect Cash Flow when the BILL is paid. 
                // The BILL payment is usually a transfer or a Despesa on a CHECKING account.
                // WE WILL KEEP PREVIOUS LOGIC: Ignore items directly on CC accounts to avoid double counting if bill is also launched.
                if (ccIds.includes(l.conta_id)) return;

                const idx = getBucketIndex(l.data_pagamento);
                if (idx !== -1) {
                    const val = parseFloat(l.valor || 0);
                    const sinal = (String(l.tipo).toUpperCase() === 'RECEITA') ? 1 : -1;
                    buckets[idx].real += val * sinal;
                }
            });

            // Populate Buckets - Projetado
            qProj.forEach(l => {
                if (!l.data_vencimento) return;

                const isPending = l.status !== 'Pago';
                const isPaidCC = (l.status === 'Pago' && ccIds.includes(l.conta_id)); // Paid items on CC are projected for bill date

                if (isPending || isPaidCC) {
                    let targetDate = l.data_vencimento;

                    // If it's a CC expense, move to bill due date
                    if (ccIds.includes(l.conta_id)) {
                        targetDate = getCartaoTargetDate(l.data_vencimento, l.conta_id);
                    }

                    const idx = getBucketIndex(targetDate);
                    if (idx !== -1) {
                        const val = parseFloat(l.valor || 0);
                        const sinal = (String(l.tipo).toUpperCase() === 'RECEITA') ? 1 : -1;
                        buckets[idx].proj += val * sinal;
                    }
                }
            });

            // Accumulate Values
            const dataReal = [];
            const dataProj = [];
            const labels = [];

            let accReal = saldoInicial;
            let accProj = saldoInicial;

            // We iterate buckets. 
            // For 'Realized', we stop at current month? Or show partial? 
            // User request: "Projete um ano a frente". Usually Realized is past, Projected is future.
            // Mixed approach: Up to today, use Realized. From tomorrow, use Projected?
            // inherited logic was separate lines. Let's keep separate lines but maybe merge logic?
            // "Fluxo de Caixa (Realizado vs Projetado)" usually means:
            // Line 1: Realized History (stops at today)
            // Line 2: Projected History + Future (shows what WAS planned vs what WILL be)

            // To make the graph look nice/continuous, Projected usually starts from Initial Balance too.

            // Logic improvement: 
            // Realized Line: changes with 'real' bucket values. Stops after current month (or keeps going flat/zero).
            // Projected Line: changes with 'proj' bucket values. Covers full range.

            // NOTE: 'buckets[i].proj' currently only has PENDING items. It misses PAID items that were projected in the past.
            // If we want "Projected" line to show "What was expected", we should ideally include Paid items as well in Projected bucket?
            // The previous code did: `if (isPending || isPaidCond)` -> it INCLUDED paid CC items in projected, but what about paid normal items?
            // Previous code: `if (isPending || isPaidCond)` -> Logic seems to imply "What is still to come" OR "What is on CC waiting for bill".
            // It did NOT seem to reconstruct the full "Past Projected" history including verified payments.
            // WE WILL STICK TIGHTLY TO PREVIOUS LOGIC DEFINITION to minimize regression risks, just expanding the timeline.

            // UPDATE: To make "Projetado" line useful in the PAST, it should probably match Realized or include everything.
            // HOWEVER, the user asked for "Projetado x Realizado". 
            // Often this means: Green line = What actually happened. Blue dashed = What is scheduled.
            // If I only put Pending in Projected, the Blue line will drop to zero/negative in the past (because old items are paid).
            // FIX: For the PAST, Projected should probably assume "Realized" values if no Pending exists? 
            // OR, we simply plot what is pending. 
            // Let's assume the user wants to see the "Cash Flow Forecast" extending from now.
            // But they said "1 year back". 
            // If I plot "Pending" 1 year back, it will be near zero (hopefully). 
            // Maybe they want to see the "Done" 1 year back and "Forecast" 1 year forward.
            // Let's Accumulate:

            const currentIsoMonth = today.toISOString().slice(0, 7); // YYYY-MM

            buckets.forEach(b => {
                labels.push(b.label);

                // Realized Accumulation
                accReal += b.real;

                // For Projected: 
                // If we want a continuous line that matches reality up to now and projects future:
                // We should add b.real to accProj IF strictly past? 
                // Or does b.proj contain "Paid" items too?
                // In my fetch above, pProj fetches NEQ 'Cancelado'. It fetches 'Pago' too?
                // Query: .neq('status', 'Cancelado'). It DOES include 'Pago'.
                // But my filter loops: `const isPending = l.status !== 'Pago';`
                // So I am explicitly EXCLUDING 'Pago' from Projected (except CC).
                // THIS CAUSES PROJECTED LINE TO BE EMPTY IN PAST.
                // FIX: To show valid "Projected" history (i.e. what happened + what is pending), we should include 'Pago' in Projected accumulation?
                // OR, just make Projected = Realized in the past + Pending in future.
                // Let's try: accProj += (b.real + b.proj). 
                // (Assuming b.proj contains only the "Pending" delta, and b.real contains the "Done" delta).
                // If I have a Pending bill for $100 today. b.proj=$100, b.real=0. accProj increases.
                // If I paid it. b.proj=0, b.real=$100. accProj increases.
                // So accProj = accProj + b.real + b.proj seems a safe approximation for "Total Expected Cash Flow".
                // But wait, `b.real` excludes CC. `b.proj` includes CC. That works.
                // What about "Pending" items in the past? (Overdue). They are in `b.proj`.

                accProj += (b.real + b.proj);

                // Push Data
                // Realized: Only up to current month? Or all if data exists?
                // Usually Realized curve stops at "today".
                // Let's check if bucket month <= current month.
                // Compare b.key vs currentIsoMonth
                if (b.key <= currentIsoMonth) {
                    dataReal.push(accReal);
                } else {
                    dataReal.push(null); // Stop drawing green line
                }

                dataProj.push(accProj);
            });


            // --- 4. RENDER ---
            if (this.charts.fluxo) this.charts.fluxo.destroy();

            this.charts.fluxo = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Realizado',
                            data: dataReal,
                            borderColor: '#10b981',
                            backgroundColor: 'rgba(16, 185, 129, 0.1)',
                            borderWidth: 3,
                            tension: 0.3,
                            fill: true,
                            pointRadius: 4,
                            order: 1,
                            spanGaps: false
                        },
                        {
                            label: 'Projetado',
                            data: dataProj,
                            borderColor: '#3b82f6',
                            borderDash: [5, 5],
                            backgroundColor: 'rgba(59, 130, 246, 0.05)',
                            borderWidth: 2,
                            tension: 0.3,
                            fill: false,
                            pointRadius: 3,
                            order: 2
                        }
                    ]
                },
                options: {
                    responsive: true, maintainAspectRatio: false,
                    interaction: { mode: 'index', intersect: false },
                    plugins: {
                        legend: { display: true, position: 'bottom' },
                        tooltip: {
                            callbacks: {
                                label: (c) => c.dataset.label + ': ' + new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(c.raw)
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: { display: false }
                        },
                        y: {
                            border: { dash: [4, 4] },
                            grid: { color: '#f3f4f6' },
                            ticks: { callback: (v) => new Intl.NumberFormat('pt-BR', { notation: 'compact' }).format(v) }
                        }
                    }
                }
            });

        } catch (e) {
            console.error('Error RenderFluxo', e);
            ctx.parentElement.innerHTML = `<div style="color:red; margin:20px; text-align:center;">Erro: ${e.message}</div>`;
        }
    },

    renderPartnersChart: function (data, type) {
        if (!data || !data.lancamentos) return;

        const map = {};

        data.lancamentos.forEach(l => {
            let nome = '';
            if (l.parceiros) {
                if (Array.isArray(l.parceiros) && l.parceiros.length > 0) nome = l.parceiros[0].nome;
                else if (l.parceiros.nome) nome = l.parceiros.nome;
            }
            if ((!nome) && window.FazendaRP.ParceirosData) {
                const p = window.FazendaRP.ParceirosData.find(pd => pd.id == l.parceiro_id);
                if (p) nome = p.nome;
            }
            if (!nome) nome = 'Sem Nome';

            if (type === 'fornecedores' && (l.tipo === 'Despesa' || l.tipo === 'DESPESA')) {
                map[nome] = (map[nome] || 0) + l.valor;
            } else if (type === 'clientes' && (l.tipo === 'Receita' || l.tipo === 'RECEITA')) {
                map[nome] = (map[nome] || 0) + l.valor;
            }
        });

        // Sorted
        const sorted = Object.entries(map)
            .filter(([k, v]) => v > 10)
            .map(([k, v]) => ({ name: k, val: v }))
            .sort((a, b) => b.val - a.val)
            .slice(0, 5);

        const ctx = document.getElementById('chartPartners');
        if (!ctx) return;
        if (this.charts.partners) this.charts.partners.destroy();

        // --- PIE CHART (DOUGHNUT) ---
        this.charts.partners = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: sorted.map(s => s.name),
                datasets: [{
                    data: sorted.map(s => s.val),
                    backgroundColor: ['#f59e0b', '#3b82f6', '#10b981', '#ef4444', '#8b5cf6'],
                    borderWidth: 1,
                    hoverOffset: 4
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'right',
                        labels: { boxWidth: 12, font: { size: 10 } }
                    },
                    tooltip: {
                        callbacks: {
                            label: (c) => {
                                const val = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(c.raw);
                                return ` ${val}`;
                            }
                        }
                    }
                },
                layout: { padding: 10 }
            }
        });
    },

    renderSafrasTable: function (map, safrasDef) {
        const tbody = document.getElementById('table-safras-body');
        if (!tbody) return;

        const safraNameStart = {};
        if (safrasDef) safrasDef.forEach(s => safraNameStart[s.id] = s.nome);

        if (Object.keys(map).length === 0) {
            tbody.innerHTML = '<tr><td colspan="4" style="text-align:center; padding:20px; color:#9ca3af;">Nenhuma safra identificada.<br><small>Verifique Detalhes dos Lançamentos.</small></td></tr>';
            return;
        }

        const sorted = Object.entries(map).sort((a, b) => (b[1].rec - b[1].desp) - (a[1].rec - a[1].desp));

        tbody.innerHTML = sorted.map(([id, val]) => {
            const lucro = val.rec - val.desp;
            const nome = safraNameStart[id] || 'Outra Safra';
            return `
                <tr style="border-bottom:1px solid #f9fafb;">
                    <td style="padding:10px; font-weight:600; color:#374151;">${nome}</td>
                    <td style="padding:10px; text-align:right; color:#10b981;">${val.rec.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td style="padding:10px; text-align:right; color:#ef4444;">${val.desp.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td style="padding:10px; text-align:right; font-weight:700; color:${lucro >= 0 ? '#10b981' : '#ef4444'};">${lucro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
            `
        }).join('');
    },

    renderOverdue: function (list) {
        const container = document.getElementById('list-alerts');
        if (!container) return;

        if (!list || list.length === 0) {
            container.innerHTML = '<div style="text-align:center; padding:20px; color:#10b981;"><i class="fas fa-check-circle" style="font-size:2rem; margin-bottom:10px;"></i><br>Tudo em dia!</div>';
            return;
        }

        container.innerHTML = list.map(item => {
            const val = parseFloat(item.valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            // Handle parceiros being object or array or null
            let pNome = 'Sem Nome';
            if (item.parceiros) {
                if (Array.isArray(item.parceiros) && item.parceiros.length > 0) pNome = item.parceiros[0].nome;
                else if (item.parceiros.nome) pNome = item.parceiros.nome;
            }

            const dataVenc = item.data_vencimento ? item.data_vencimento.split('-').reverse().join('/') : '-';

            return `
                <div style="padding:10px 15px; border-bottom:1px solid #fecaca; background:#fff1f2; display:flex; justify-content:space-between; align-items:center;">
                    <div>
                        <div style="font-weight:600; color:#7f1d1d; font-size:0.9rem;">${pNome}</div>
                        <div style="font-size:0.8rem; color:#991b1b;">Venceu: ${dataVenc}</div>
                        <div style="font-size:0.75rem; color:#ef4444; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:120px;">${item.descricao || ''}</div>
                    </div>
                    <div style="font-weight:700; color:#b91c1c;">${val}</div>
                </div>
            `;
        }).join('');
    },

    fetchCardBalance: async function () {
        try {
            const { data: movs } = await window.FazendaRP.supabase
                .from('financeiro_movimentacoes')
                .select('valor, tipo, financeiro_contas!inner(tipo)')
                .ilike('financeiro_contas.tipo', '%Cartão%')
                .neq('status', 'Cancelado');
            if (!movs) return 0;
            let saldo = 0;
            movs.forEach(m => { if (m.tipo === 'CREDITO') saldo += m.valor; else saldo -= m.valor; });
            return saldo;
        } catch (e) { return 0; }
    }
};
